import { NgModule } from '@angular/core';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { EmployerSelectionModalComponent } from './employer-selection-modal/employer-selection-modal.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ReportsListComponent,
    EmployerSelectionModalComponent
  ],
  providers: [],
  exports: [],
})
export class ReportsModule { }